import { useCallback } from 'react';
import type { SearchParamsWriteOptions } from './use-search-params';

interface TabSearch {
    params: { tab?: unknown };
    setParams: (
        params: { tab: string },
        options: SearchParamsWriteOptions
    ) => void;
}

/** `search` must be the page's own `useSearchParams` instance, the one its
 * filter writes through: a second instance would clobber those writes. */
export function useTabSearchParam<K extends string>(
    search: TabSearch,
    keys: readonly K[],
    defaultKey: K
): [K, (key: K) => void] {
    const { params, setParams } = search;
    const activeKey = keys.find((key) => key === params.tab) ?? defaultKey;

    const setTab = useCallback(
        (key: K) => setParams({ tab: key }, { push: true }),
        [setParams]
    );

    return [activeKey, setTab];
}
